import {Drawer as AntdDrawer} from 'antd';
import styled from 'styled-components';

import {ThemeVarNames} from '@theme';

export const Drawer = styled(AntdDrawer)`
  transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);

  .ant-drawer-content-wrapper {
    transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
    will-change: transform;
  }

  &.ant-drawer-left .ant-drawer-content-wrapper {
    transform: translateX(-100%);
  }

  &.ant-drawer-right .ant-drawer-content-wrapper {
    transform: translateX(100%);
  }

  &.ant-drawer-top .ant-drawer-content-wrapper {
    transform: translateY(-100%);
  }

  &.ant-drawer-bottom .ant-drawer-content-wrapper {
    transform: translateY(100%);
  }

  &.ant-drawer-open .ant-drawer-content-wrapper {
    transform: translate(0, 0);
  }

  .ant-drawer-header,
  .ant-drawer-header-no-title {
    background-color: var(${ThemeVarNames.PrimaryBg});
    border-bottom-color: var(${ThemeVarNames.Border});
    border-radius: unset;
  }

  .ant-drawer-title {
    color: var(${ThemeVarNames.SecondaryText});
  }

  .ant-drawer-close {
    color: var(${ThemeVarNames.PrimaryText});
  }

  .ant-drawer-close:hover {
    color: var(${ThemeVarNames.TertiaryText});
  }

  .ant-drawer-body {
    display: flex;
    flex-direction: row;
    padding-left: 0;
    padding-bottom: 0;
    background-color: var(${ThemeVarNames.SecondaryBg});
  }

  .ant-tabs {
    width: 100%;
  }

  .ant-tabs-content-holder {
    overflow: auto;
  }
`;
